import { render, staticRenderFns } from "./DrugTable.vue?vue&type=template&id=e9aa712e&scoped=true"
import script from "./DrugTable.vue?vue&type=script&lang=js"
export * from "./DrugTable.vue?vue&type=script&lang=js"
import style0 from "./DrugTable.vue?vue&type=style&index=0&id=e9aa712e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9aa712e",
  null
  
)

export default component.exports